import AppSystemWebApiPagingResultModelBase from '../_generated/modelBases/app-system-web-api-paging-result-model-base';

export default class AppSystemWebApiPagingResultModel extends AppSystemWebApiPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
